import { useNavigate, useParams } from "react-router-dom";
import { useContext, useState } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import { TextLeft, TextParagraph, Table, CardText, Translate } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function AddNomen() {
    // states
    let table = useParams();
    let type = useParams();
    let parent = useParams();
    let dom = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);

    const [lib1, setLib1] = useState("");
    const [abrev1, setAbrev1] = useState("");
    const [lib2, setLib2] = useState("");
    const [abrev2, setAbrev2] = useState("");
    const [nomen, setNomen] = useState("");
    const [nomenlist, setNomentlist] = useState([]);

    const [libtitrevueliste, setLibtitrevueliste] = useState("");
    const [libtitrevuenouveau, setLibtitrevuenouveau] = useState("");
    const [libtitrevueedit, setLibtitrevueedit] = useState("");

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getDomaine = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", user.token);
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains/${dom.domain}`, requestOptions).then((response) => {

            if (response?.status !== 200) {
                // console.log("response", response);
            } else {
                response.json().then(async (data) => {
                    // console.log("body", data);
                    if (data?.head) {
                        let body = data?.body;

                        setLibtitrevueliste(body?.libtitrevuelistdom !== null ? body?.libtitrevuelistdom : "");
                        setLibtitrevuenouveau(body?.libtitrevuenouvdom !== null ? body?.libtitrevuenouvdom : "");
                        setLibtitrevueedit(body?.libtitrevueeditdom !== null ? body?.libtitrevueeditdom : "");

                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("operating error...");
                        }
                    }
                })
            }

        }).catch((err) => {
            // console.log("error", err);
        });
    }

    const getNomenList = async () => {
        if (parent.parent) {

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.domain.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns/${parent.parent}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];

                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                clientarraydata.push({ label: element.lib, value: element.code });
                            });

                            setNomentlist(clientarraydata);
                        } else {
                            if (data?.body?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // console.log("data error: fail");
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    // console.log("data error: fail");
                }

            }).catch((err) => {
                // console.log("error", err);
            });
        }
    }



    // comportements
    useEffect(() => {
        getDomaine();
        getNomenList();
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);



        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("nomtab", table.table);
        urlencoded.append("lib", lib1);
        urlencoded.append("abrev", abrev1);
        if (parent.parent) urlencoded.append("codeparent", nomen["value"]);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else if (data?.body?.msg === "libelleexistant") {
                            setFetching(false);
                            showWarningMessage("Ce libelle est déjà utilisé par un autre domaine.");
                        } else {
                            setFetching(false);
                            showErrorMessage(textes.fr.requestfail);
                        }
                    } else {
                        showSuccesMessage("Nomenclature ajouté avec succès");
                        setFetching(false);
                        navigate(-1);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
            setFetching(false);
        });
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Nomenclatures</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Go Back</span>
                            </button>
                            <h6 className="m-0 ">{libtitrevuenouveau}</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="type" className="mb-1">Type de nomenclature</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="type">
                                                        <CardText />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        value={type.type}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="table" className="mb-1">Table</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="table">
                                                        <Table />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le nom de la table"
                                                        value={table.table}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="fra" className="mb-1">Français</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="fra">
                                                        <Translate />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={"fra"}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="eng" className="mb-1">Englais</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="eng">
                                                        <Translate />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={"eng"}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="libfra" className="mb-1">Libelle français</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="libfra">
                                                        <TextParagraph />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le libelle de la nomenclature en français"
                                                        value={lib1}
                                                        onChange={(e) => setLib1(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="libeng" className="mb-1">Libelle anglais</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="libeng">
                                                        <TextParagraph />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le libelle de la nomenclature en anglais"
                                                        value={lib2}
                                                        onChange={(e) => setLib2(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="abrevfra" className="mb-1">Abréviation français</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="abrevfra">
                                                        <TextLeft />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez l'abréviation"
                                                        value={abrev1}
                                                        onChange={(e) => setAbrev1(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="abreveng" className="mb-1">Abréviation anglais</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="abreveng">
                                                        <TextLeft />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez l'abréviation"
                                                        value={abrev2}
                                                        onChange={(e) => setAbrev2(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            {parent.parent && <div className="col-md-6 mb-3">
                                                <label className="mb-1" htmlFor="parent">Parent</label>
                                                <Select
                                                    id="parent"
                                                    name="parent"
                                                    options={nomenlist}
                                                    value={nomen}
                                                    onChange={(selected) => {
                                                        setNomen(selected);
                                                    }}
                                                />
                                            </div>}


                                        </div>
                                    </div>
                                    {parent.parent === undefined && <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Ajouter une nouvelle nomenclature"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={lib1 && abrev1 ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Ajouter</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>}
                                    {parent.parent !== undefined && <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Ajouter une nouvelle nomenclature"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={lib1 && abrev1 && nomen["value"] ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Ajouter</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}